/* eslint-disable no-unused-vars */
import axios from "../../axios";

export default {
  namespaced: true,
  state: {
    courses: [],
    pagination: {
      current_page: 1,
      per_page: 15,
      total: 0,
    },
  },
  mutations: {
    SET_LIST(state, data) {
      state.courses = data.items || data;
      state.pagination = data.pagination;
    },
    SET_CURRENT_PAGE(state, page) {
      state.pagination.current_page = page;
    },
    SET_PER_PAGE(state, size) {
      state.pagination.per_page = size;
    },
  },
  actions: {
    async getVoucherCourses({ commit }, { user_id, query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`vouchers/${user_id}/my-courses?${new URLSearchParams(query)}`)
          .then((response) => {
            commit("SET_LIST", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * set current page
     * @param commit
     * @param page
     */
    setCurrentPage({ commit }, page) {
      commit("SET_CURRENT_PAGE", page);
    },

    /**
     * set per page
     * @param commit
     * @param size
     */
    setPerPage({ commit }, size) {
      commit("SET_PER_PAGE", size);
    },
  },
  getters: {},
};
